import { render, staticRenderFns } from "./OidcCallbackPage.vue?vue&type=template&id=1c6c18a6"
import script from "./OidcCallbackPage.vue?vue&type=script&lang=js"
export * from "./OidcCallbackPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports